import React from 'react';
import { Drawer, Row, Col, Typography } from 'antd';
import StatsCard from '../../components/shared/StatsCard';
import { Equipment } from '../../types';

const { Title } = Typography;

interface EquipmentStatsDrawerProps {
  visible: boolean;
  equipment: Equipment[];
  onClose: () => void;
}

const EquipmentStatsDrawer: React.FC<EquipmentStatsDrawerProps> = ({
  visible,
  equipment,
  onClose,
}) => {
  const getStats = () => [
    { title: 'Total Equipment', value: equipment.length },
    { title: 'Available', value: equipment.filter(e => e.status === 'Available').length },
    { title: 'In Use', value: equipment.filter(e => e.status === 'In Use').length },
    { title: 'Avg Utilization', value: 78, suffix: '%' },
  ];

  return (
    <Drawer
      title={<Title level={3}>Equipment Statistics</Title>}
      placement="right"
      onClose={onClose}
      open={visible}
      width={500}
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <StatsCard
            title="Overview"
            stats={getStats()}
            size="small"
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default EquipmentStatsDrawer; 